import { Component, OnInit, Input,ViewChild,ElementRef } from '@angular/core';


@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent implements OnInit {

  @Input() content : string;
  
  @ViewChild('texte', {static: true}) texte : ElementRef;
  

  constructor() { }

  ngOnInit() {}

  ngOnChanges() {
      
    this.texte.nativeElement.innerHTML = this.content;
  
 }


}
